import { PayloadAction } from '@reduxjs/toolkit';
import { Event } from 'dataSources/Typicode/events/types';

import { IState } from '../types/state';

const setEvents = (state: IState, action: PayloadAction<Event[]>) => {
  state.specialEvents.data = action.payload;
};

export default setEvents;
